import Maska from "maska";

export default {
  install: function(app /*, options*/) {
    app.use(Maska);
  }
};
